import { Capacitor } from '@capacitor/core';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let initialized = false;

export async function initNativePush() {
  if (initialized || !Capacitor.isNativePlatform()) return;
  if (!Capacitor.isPluginAvailable('FirebaseMessaging')) return; // older app shells
  initialized = true;
  try {
    const { FirebaseMessaging } = await import('@capacitor-firebase/messaging');

    const perm = await FirebaseMessaging.requestPermissions();
    if (perm.receive !== 'granted') return;

    const { token } = await FirebaseMessaging.getToken();
    if (token) {
      await axios.post(`${API}/notifications/register-native`, {
        token,
        platform: Capacitor.getPlatform(),
      });
    }

    FirebaseMessaging.addListener('tokenReceived', async ({ token: newToken }) => {
      if (newToken) {
        try {
          await axios.post(`${API}/notifications/register-native`, {
            token: newToken,
            platform: Capacitor.getPlatform(),
          });
        } catch (err) { console.error('Native push token registration failed (will retry next launch):', err); }
      }
    });

    FirebaseMessaging.addListener('notificationActionPerformed', ({ notification }) => {
      const url = notification?.data?.url;
      if (url && url.startsWith('/')) window.location.href = url;
    });
  } catch (e) {
    initialized = false;
    console.warn('Native push init failed:', e?.message || e);
  }
}
